
import React, { useState } from "react";
import { FilterSection, AdvancedFilters } from "../../../components/ui";
import { SearchBar, FormSelect, Button } from "../../../components/ui";
import { Search, X, Plus, Calendar, Filter, Settings } from "lucide-react";
import { fmtDate } from "../../../lib/formatters";

/**
 * InventoryControlPanel Component
 * Refactored to use the standard FilterSection pattern from the new-frontend design system.
 */
export const InventoryControlPanel = ({
  activeTab,
  search, setSearch,
  filters, setFilters,
  dynamicSettings,
  onAddItemClick,
  buttonLabel = "New Item",
  onBackClick,
  showBack = false,
  categories: customCategories,
  parties,
  partyLabel = "Vendors",
  showStatusFilter = true,
  onExport,
  isExporting,
  onManageVersions,
  customActions
}) => {
  const [showAdvanced, setShowAdvanced] = useState(false);

  const handleFilterChange = (key, value) => {
    setFilters(prev => ({ ...prev, [key]: value }));
  };

  // Status options for the standard FilterSection
  const statusOptions = showStatusFilter ? [
    { value: 'in', label: 'In Stock' },
    { value: 'low', label: 'Low Stock' },
    { value: 'out', label: 'Out of Stock' }
  ] : [];

  return (
    <FilterSection
      search={search}
      setSearch={setSearch}
      filters={filters}
      setFilters={(key, val) => handleFilterChange(key, val)}
      onAddClick={onAddItemClick}
      addLabel={buttonLabel}
      statusOptions={statusOptions}
      onExport={onExport}
      isExporting={isExporting}
      customActions={customActions}
      // showAdvancedFilters={showAdvanced}
      // setShowAdvancedFilters={setShowAdvanced}
      // AdvancedFiltersComponent={() => (
      //   <div className="card p-5 mt-3 border border-slate-100 bg-white shadow-xl shadow-slate-100/50 animate-in slide-in-from-top-2 duration-300">
      //      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
      //         <div className="text-[11px] text-slate-500 italic">
      //           Advanced filter options will appear here.
      //         </div>
      //      </div>
      //   </div>
      // )}
    >
      {/* Category Dropdown - commented out
      <div className="bg-slate-50/50 p-1 rounded-md border border-slate-200/60 shrink-0 flex items-center gap-2">
        <select
          className="text-[13px] font-medium bg-white border border-slate-200 rounded-md px-2 py-1.5 focus:outline-none focus:ring-1 focus:ring-brand-blue text-slate-600 w-44"
          value={filters.category || "all"}
          onChange={e => handleFilterChange('category', e.target.value)}
        >
          <option value="all">All Categories</option>
          {(customCategories || dynamicSettings?.cats)?.map(c => {
              const label = c.categoryName || c.title || c.name || (typeof c === 'string' ? c : "");
              const safeLabel = typeof label === 'object' ? "—" : (label || "—");
              return <option key={c._id || String(safeLabel)} value={String(safeLabel)}>{String(safeLabel)}</option>
          })}
        </select>
      </div>
      */}

      {/* Sub Category Dropdown - commented out
      <div className="bg-slate-50/50 p-1 rounded-md border border-slate-200/60 shrink-0 flex items-center gap-2">
        <select
          className="text-[13px] font-medium bg-white border border-slate-200 rounded-md px-2 py-1.5 focus:outline-none focus:ring-1 focus:ring-brand-blue text-slate-600 w-44"
          value={filters.subCategory || "all"}
          onChange={e => handleFilterChange('subCategory', e.target.value)}
        >
          <option value="all">All Sub Categories</option>
          {(dynamicSettings?.subCats || [])?.filter(sc => {
              const scCat = String(typeof sc.category === 'object' ? (sc.category?.categoryName || sc.category?.name || sc.category?.title) : (sc.category || "")).trim().toLowerCase();
              const filterCat = String(filters.category || "").trim().toLowerCase();
              return filters.category === 'all' || scCat === filterCat;
          }).map(c => {
              const label = c.subCategoryName || c.title || c.name || (typeof c === 'string' ? c : "");
              const safeLabel = typeof label === 'object' ? "—" : (label || "—");
              return <option key={c._id || String(safeLabel)} value={String(safeLabel)}>{String(safeLabel)}</option>
          })}
        </select>
      </div>
      */}

      {/* Vendor / Supplier Dropdown */}
      <div className="bg-slate-50/50 p-1 rounded-md border border-slate-200/60 shrink-0 flex items-center gap-2">
        <select
          className="text-[13px] font-medium bg-white border border-slate-200 rounded-md px-2 py-1.5 focus:outline-none focus:ring-1 focus:ring-brand-blue text-slate-600 w-36"
          value={filters.supplier || "all"}
          onChange={e => handleFilterChange('supplier', e.target.value)}
        >
          <option value="all">All {partyLabel}</option>
          {(parties || dynamicSettings?.suppliers)?.map(p => {
              const label = p.vendorName || p.name || p.title || (typeof p === 'string' ? p : "");
              const safeLabel = typeof label === 'object' ? "—" : (label || "—");
              return <option key={p._id || String(safeLabel)} value={p._id || String(safeLabel)}>{String(label)}</option>
          })}
        </select>
      </div>

      {showBack && (
        <Button
          variant="secondary"
          size="sm"
          onClick={onBackClick}
          className="h-9 px-4 text-[10px] font-black uppercase tracking-widest"
          leftIcon={<svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3}><path d="M15 19l-7-7 7-7" /></svg>}
        >
          BACK
        </Button>
      )}

      {/* {onManageVersions && (
        <Button
          variant="secondary"
          size="sm"
          onClick={onManageVersions}
          className="h-9 px-4 text-[12px] font-bold text-slate-700 bg-white border border-slate-200 hover:bg-slate-50 transition-colors shadow-sm ml-auto"
          leftIcon={<Settings size={16} />}
        >
          Manage Versions
        </Button>
      )} */}
    </FilterSection>
  );
};

